import { commonColors } from 'applicaiton/theme';
import styled from 'styled-components';

interface Props {
  isError?: boolean;
}

interface TabItemProps {
  active: boolean;
}

export const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex-grow: 1;
`;

export const SubscriptionSection = styled.div`
  display: grid;
  gap: 12px;

  > p {
    font-family: Mulish;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    color: ${({ theme }) => theme.color.grey600};
  }

  > button {
    width: max-content;

    svg {
      path {
        fill: ${({ theme }) => theme.color.grey700};
      }
    }
  }
`;

export const DropdownSection = styled.section`
  display: grid;
  width: 100%;
  gap: 24px;
  margin-bottom: 24px;
`;

export const RadioButtonSection = styled.section<Props>`
  display: grid;
  width: 100%;
  gap: 12px;
  margin-bottom: 24px;

  > p {
    color: ${({ theme, isError }) =>
      isError ? theme.color.error2 : theme.color.grey600};
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
  }

  > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.07px;
    color: ${({ theme }) => theme.color.error2};
  }
`;

export const StyledDivider = styled.div`
  height: 1px;
  margin: 32px 0;
  background-color: ${({ theme }) => theme.color.grey200};
`;

export const TextAreaSection = styled.div`
  margin-bottom: 24px;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    width: 150px;
    &:last-child {
      margin-left: 20px;
    }
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 0;

  &.filtered-list-empty {
    margin-top: 20px;
  }

  p {
    color: ${({ theme }) => theme.color.grey700};
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.04px;

    span {
      font-weight: 900;
      color: ${({ theme }) => theme.color.blue800};
    }
  }

  button {
    width: auto;

    svg {
      path {
        fill: ${({ theme }) => theme.color.grey700};
      }
    }
  }
`;

export const TabsSection = styled.div`
  display: flex;
  align-items: center;
`;

export const TabItem = styled.button<TabItemProps>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;

  display: flex;
  min-width: 190px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid ${commonColors.grey300};
  background: ${({ active }) =>
    active ? commonColors.blueLight50 : commonColors.white};

  color: ${commonColors.grey900};
  font-size: 16px;
  font-weight: ${({ active }) => (active ? 700 : 500)};
  line-height: 140%;
  letter-spacing: 0.08px;

  &:first-of-type {
    border-radius: 8px 0 0 8px;
  }

  &:last-of-type {
    border-radius: 0 8px 8px 0;
    border-left: 0;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
`;
